import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useI18n } from '../../lib/hook/useI18n';
import useStyles from './DeleteFolderDialog.styles';

interface DeleteFolderDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const DeleteFolderDialog: React.FC<DeleteFolderDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const { t } = useI18n();
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={loading}
    >
      <DialogTitle>
        {t('room.folder.delete.title')}
        <IconButton
          aria-label="close"
          onClick={onClose}
          disabled={loading}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1">
          {t('room.folder.delete.message')}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          className={classes.useErrorColor}
        >
          {t('room.folder.delete.confirm')}
        </Button>
        <Button onClick={onClose} disabled={loading} variant="outlined">
          {t('room.folder.create_cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
